// extracted by mini-css-extract-plugin
module.exports = {"register":"RegisterRecruiter_register__22qqW","registerContainer":"RegisterRecruiter_registerContainer__9ZEi3","phoneInput":"RegisterRecruiter_phoneInput__1sPN1"};